import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
/* CHANGED in 1.17.0-dev.1: the Vikar Experten design tokens must load before
   anything else, because the hand-written .css files (AdminLayout.css,
   Login.css, Dashboard.css, …) reference these custom properties. */
import './styles/ve-tokens.css';

// Add error boundary for development debugging
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("React Error Boundary caught an error:", error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      /* CHANGED: the crash panel was a red-bordered rounded box in Arial. It is
         now square, Roboto, and uses the brand's danger red — this is the one
         screen a user should never see, but it should still look like ours. */
      return (
        <div style={{
          padding: '25px',
          backgroundColor: '#ffffff',
          border: '3px solid #c3251d',
          margin: '30px',
          fontFamily: "'Roboto', Helvetica, Arial, sans-serif",
          fontWeight: 300,
          lineHeight: 1.625,
          color: '#333333'
        }}>
          <h2 style={{
            color: '#c3251d',
            fontSize: '24px',
            fontWeight: 700,
            textTransform: 'uppercase',
            lineHeight: 1.2,
            margin: '0 0 15px'
          }}>
            Der opstod en fejl
          </h2>
          <details style={{ whiteSpace: 'pre-wrap', margin: '10px 0' }}>
            <summary>Error Details</summary>
            <p>{this.state.error && this.state.error.toString()}</p>
            <p>Component Stack: {this.state.errorInfo && this.state.errorInfo.componentStack}</p>
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
